import React, { Component } from 'react';
import { Grid, Header, Divider } from 'semantic-ui-react';
import { Form, Input } from 'formik-semantic-ui';

class CustomerSocialMedia extends Component {
  render() {
    return (
      <Form.Children>
        <Grid columns={2} divided>
          <Grid.Row>
            <Grid.Column>
              <Header as="h3">Social Media </Header>
              <Input
                inputProps={{
                  icon: 'facebook',
                  iconPosition: 'left',
                  placeholder: 'https://www.facebook.com/myprofile'
                }}
                label="Facebook Page"
                name="facebook"
              />
              <Input
                inputProps={{
                  icon: 'instagram',
                  iconPosition: 'left',
                  placeholder: 'https://www.instagram.com/myprofile'
                }}
                label="Instagram Page"
                name="instagram"
              />
              <Input
                inputProps={{
                  icon: 'twitter',
                  iconPosition: 'left',
                  placeholder: 'https://www.twitter.com/myprofile'
                }}
                label="Twitter Page"
                name="twitter"
              />
              <Input
                inputProps={{
                  icon: 'youtube',
                  iconPosition: 'left',
                  placeholder: 'https://www.youtube.com/user/user_name'
                }}
                label="Youtube Channel"
                name="youtube"
              />
              <Input
                inputProps={{
                  icon: 'spotify',
                  iconPosition: 'left',
                  placeholder: 'https://www.spotify.com/myprofile'
                }}
                label="Spotify URL"
                name="spotify"
              />
              <Input
                inputProps={{
                  icon: 'soundcloud',
                  iconPosition: 'left',
                  placeholder: 'https://www.soundcloud.com/myprofile'
                }}
                label="Soundcloud URL"
                name="soundcloud"
              />
              <Input
                inputProps={{
                  icon: 'patreon',
                  iconPosition: 'left',
                  placeholder: 'https://www.patreon.com/myprofile'
                }}
                label="Patreon URL"
                name="patreon"
              />
            </Grid.Column>
            <Grid.Column>
              <Divider hidden />
              <Input
                inputProps={{
                  icon: 'music',
                  iconPosition: 'left',
                  placeholder: 'https://www.buymusic.com/user/user_name'
                }}
                label="URL to buy your music"
                name="buyOnline"
              />
              <Input
                inputProps={{
                  icon: 'music',
                  iconPosition: 'left',
                  placeholder: 'https://www.buymusic.com/user/user_name'
                }}
                label="URL to buy your music"
                name="buyOnline2"
              />
              <Input
                inputProps={{
                  icon: 'music',
                  iconPosition: 'left',
                  placeholder: 'https://www.buymusic.com/user/user_name'
                }}
                label="URL to buy your music"
                name="buyOnline3"
              />
              <Input
                inputProps={{
                  icon: 'music',
                  iconPosition: 'left',
                  placeholder: 'https://www.buymusic.com/user/user_name'
                }}
                label="URL to buy your music"
                name="buyOnline4"
              />
              <Input
                inputProps={{
                  icon: 'music',
                  iconPosition: 'left',
                  placeholder: 'https://www.othersocialsite.com/user/user_name'
                }}
                label="URL to other social media"
                name="otherSocial"
              />
              <Input
                inputProps={{
                  icon: 'music',
                  iconPosition: 'left',
                  placeholder: 'https://www.othersocialsite.com/user/user_name'
                }}
                label="URL to other social media"
                name="otherSocial2"
              />
              <Input
                inputProps={{
                  icon: 'music',
                  iconPosition: 'left',
                  placeholder: 'https://www.othersocialsite.com/user/user_name'
                }}
                label="URL to other social media"
                name="otherSocial3"
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form.Children>
    );
  }
}

export { CustomerSocialMedia };
